import LabeledField from "providers/labeledField";
import ProfileCard from "widgets/cards/profile";
import { useTranslation } from "react-i18next";

const Details = ({ firstName = "", lastName = "", email = "" }) => {
  const { t } = useTranslation();
  return (
    <ProfileCard
      title={t("dialog.user.details.title")}
      bgColor="bg-background-50"
      textColor="text-white"
      extra="h-full"
    >
      <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-5">
        <LabeledField
          className="text-txt-xs"
          textColor="white"
          label={t("dialog.user.details.first_name")}
          id={"user-first-name"}
        >
          <div className="text-txt-lg text-white">
            {firstName || t("dialog.user.details.first_name")}
          </div>
        </LabeledField>
        <LabeledField
          className="text-txt-xs"
          textColor="white"
          label={t("dialog.user.details.last_name")}
          id={"user-last-name"}
        >
          <div className="text-txt-lg text-white">
            {lastName || t("dialog.user.details.last_name")}
          </div>
        </LabeledField>
      </div>
      <div className="mt-2 grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-5">
        <LabeledField
          className="text-txt-xs"
          textColor="white"
          label={t("dialog.user.details.email")}
          id={"user-email"}
        >
          <div className="text-txt-lg text-white">
            {email || t("dialog.user.details.email")}
          </div>
        </LabeledField>
      </div>
    </ProfileCard>
  );
};

export default Details;
